export default {
    namespaced: true,

    state: {
        // Mobile Dash
        showLogo: true,
        showBottomNav: true

    },
    mutations: {
        changeLogoVisibility (state, b) {
            state.showLogo = b;
        },

        changeBottomNavVisibility (state, b) {
            state.showBottomNav = b;
        }
    },
    actions: {
        setLogoVisibility ({ commit }, bool) {
            commit('changeLogoVisibility', bool);
            return bool;
        },

        setBottomNavVisibility ({ commit }, bool) {
            commit('changeBottomNavVisibility', bool);
            return bool;
        },

        setLogoAndBottomNavVisibility ({commit}, bool) {
            commit('changeLogoVisibility', bool);
            commit('changeBottomNavVisibility', bool);
            return bool;
        }
    },
    getters: {
        logoIsVisible: state => state.showLogo,
        bottomNavIsVisible: state => state.showBottomNav,
    },
}